import React, { PureComponent } from 'react'
import { UncontrolledTooltip } from 'reactstrap'
import HelpIcon from 'mdi-react/HelpCircleOutlineIcon'

export default class TooltipRight extends PureComponent {
  render () {
    return (
      <span>
        <HelpIcon size={15} id='TooltipRight' />
        <UncontrolledTooltip placement='right' target='TooltipRight'>
          {this.props.helpText}
        </UncontrolledTooltip>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/tooltips/components/TooltipRight.js